import React from 'react'
import { getDeadlineStatus } from '../../utils/deadlineChecker'

export default function DataSetBox({ datasetName, datasetDesc,image }) {
  return (
    <div className='datasetBoxComponent'>
      <img src={image} alt='dataset' className='datasetImage'></img>
      <div className='datasetContent'>
        <p className='datasetName'>{datasetName}</p>
        <p className='datasetDec'>{datasetDesc}</p>
        <div>
          <p className='fileTypeText'>File Type</p>
          <p className='fileType'>CSV</p>
        </div>
        <p className="downloadButton" onClick={() => {
            const status = getDeadlineStatus();
            if (!status.isOpen) {
              alert(status.message);
              return;
            }
            window.open('https://www.datavizon.com/course/DataHackathon-5HospitalityAnalytics-109659', '_blank')  
          }} > Download </p>
      </div>
    </div>
  )
}
